<div class="content h-100">
  <NavBar />
  <v-main>
    <v-container fluid>
      <v-card class="bg-white pa-5" :elevation="2">
        <div class="d-flex justify-space-between">
          <div>
            <div class="d-flex">
              <v-icon size="x-large">mdi-salesforce</v-icon>
              <div class="ml-3 text-h4">Api SalesForce</div>
            </div>
            <div>
              Migración de datos hacía SalesForce.
            </div>
          </div>
          <div class="w-25">
            <div class="d-flex justify-end">
              <v-switch inset color="success" :label="`Status: ${connect}`" false-value="disconnected" true-value="connected" v-model="connect" @click="connectApi"></v-switch>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <v-row>
            <v-col cols="2">
              <v-toolbar title="Objetos" />
              <v-card class="mt-5" variant="outlined">
                <v-card-text>
                  <v-select label="Año" :items="years" v-model="year"></v-select>
                  <v-select label="Mes" :items="months" v-model="month" item-title="label" item-value="value"></v-select>
                  <v-btn class="mt-3" color="primary" size="large" variant="tonal" block text="Buscar" @click="loadregister"/>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="10">
              <v-toolbar>
                <v-toolbar-title>Registros</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn class="mx-3" icon :elevation="0" @click="sendregister">
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-toolbar>
              <v-data-table :headers="headers" :items="donations" class="text-caption" density="compact">

              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>
  </v-main>
  <!-- #progress -->
  <v-dialog v-model="isprocess" max-width="320" persistent>
    <v-card>
      <template v-slot:title>
        <v-progress-circular color="primary" indeterminate></v-progress-circular> Por favor espera...
      </template>
      <template v-slot:subtitle>
        {{processTitle}}
      </template>
      <template v-slot:text>
        <v-progress-linear color="primary" :model-value="processValue"></v-progress-linear>
      </template>
    </v-card>   
  </v-dialog>
  <!-- #endregion -->
</div>